<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'JtProjKickoffMeeting',
})
</script>
<template>
  <Form ref="formRef" :model="model" layout="vertical" scrollToFirstError>
    <Row :gutter="16">
      <Col :xxl="4" :xl="6" :span="8">
        <FormItem label="会议时间" name="meetingTime" :rules="getRequiredRule('会议时间')">
          <DatePicker v-model:value="model.meetingTime" allowClear valueFormat="YYYY-MM-DD" placeholder="请选择" />
        </FormItem>
      </Col>
      <Col :xxl="4" :xl="6" :span="8">
        <FormItem label="会议地点" name="meetingAddress">
          <Input v-model:value="model.meetingAddress" placeholder="请输入会议地点" allowClear />
        </FormItem>
      </Col>
    </Row>
    <FormItem label="会议纪要" name="meetingSummary">
      <Input.TextArea v-model:value="model.meetingSummary" :autoSize="{ minRows: 4, maxRows: 8 }" placeholder="请输入" />
    </FormItem>
    <FormItem label="附件" name="meetingFiles">
      <FileUpload v-model:value="model.meetingFiles" />
    </FormItem>
  </Form>
  <SubmitBar
    @submit="handleSubmit"
    :submitAttrs="{
      loading: submitLoading
    }"
  />
</template>

<script lang="ts" setup name="JtProjKickoffMeeting">
import { DatePicker, Form, message, Row, Col, Input } from 'ant-design-vue'
import { computed, ref, watch } from 'vue'
import { FormItem, SubmitBar } from '-/Common/Form'
import { FileUpload } from '-/Common/FileUpload'
import { handleFormError } from '@/hooks/useForm'
import { useDetailLy } from '@/hooks/useDetailLy'
import { API_KICKOFF_MEETING_ADD } from '@/api/kickoffMeeting'
import { getRequiredRule } from '@/constant/form'
const formRef = ref()
const { id, result, refresh } = useDetailLy()
const data = computed(() => result.value?.meeting?.[0])

const model = ref<Partial<ApiKickoffMeeting.Item>>({})
const setModel = () => {
  model.value = {
    meetingTime: data.value?.meetingTime,
    meetingAddress: data.value?.meetingAddress,
    meetingSummary: data.value?.meetingSummary,
    meetingFiles: data.value?.meetingFiles
  }
}
watch(data, setModel, { immediate: true, deep: true })
const submitLoading = ref(false)
const handleSubmit = async () => {
  submitLoading.value = true
  try {
    await formRef.value?.validate()
    const params: any = {
      projectId: id.value,
      ...model.value
    }
    await API_KICKOFF_MEETING_ADD(params)
    message.success('保存成功')
    refresh()
  } catch (err) {
    handleFormError(err)
  }
  submitLoading.value = false
}
</script>
